<script>
  /**
   * @type {String} - text for max file size
   */
  export let maxSize = "2MB"
  /**
   * @type {String} - text for supported format types
   */
  export let supportedFormats = "PDF and DOCX"
</script>

<div class="relative flex h-full w-full select-none flex-col items-center justify-center gap-3 rounded-md border border-dashed border-[#a0a1a580] py-6 text-xs font-normal text-gray-100 hover:bg-[#f7f7f7] hover:dark:bg-bodyblack md:py-12">
  <input on:change type="file" accept=".pdf,.docx" class="absolute inset-0 cursor-pointer opacity-0" />

  <div class="mb-3 text-3xl text-blue-500 md:text-6xl">
    <i class="fa-solid fa-cloud-arrow-up" />
  </div>

  <span>Click here to upload your file or drag</span>
  <p>
    Supported formats:
    <span class="text-blue-500">{supportedFormats} (max {maxSize}).</span>
  </p>
</div>
